
import React, {useEffect, useRef, useState} from "react";
import {FormOutlined, DeleteOutlined, SearchOutlined, PlusOutlined, QuestionCircleOutlined,ExportOutlined} from "@ant-design/icons";
import {Breadcrumb, Button, Divider, message, Modal, Popconfirm, Popover, Space, Tag} from "antd";
import MyProLayout from "../../components/MyProLayout";
import {ActionType, ProTable} from "@ant-design/pro-components";
import FetchUtil from "../../utils/FetchUtil";
import AiGameLogs from "./AiGameLogs";
import AiGameKeys from "./AiGameKeys";
import StringUtil from "../../utils/StringUtil";
import AiGameDomain from "./AiGameDomain";

// const sortEnum = [
//     {label: '累计关键词', value: 'keys_num desc'},
//     {label: 'Ads搜索量', value: 'key_value desc, game_name'},
//     {label: '关键词更新', value: 'keys_update desc'},
//     {label: '游戏名', value: 'game_name'},
// ]

const AiGameIndex = (prop: any) => {

    const actionRef = useRef<ActionType>();
    const logsRef = useRef();
    const keysRef = useRef();
    const domainRef = useRef();

    useEffect(() => {
    }, []);

    const openKeys = (id: number) => {
        (keysRef.current as any).openEditor(id);
    }
    const openDomain = (id: number) => {
        (domainRef.current as any).openEditor(id, '');
    }

    const columns: any[] = [
        {
            title: "ID",
            dataIndex: "id",
            width: 60,
            hideInSearch: true
        },
        {
            title: "游戏",
            dataIndex: "gameName",
            width: 100,
        },
        {
            title: "来源",
            dataIndex: "website",
            width: 100,
        },
        {
            title: '原始数据日期',
            dataIndex: 'createTime',
            align: 'center' as 'center',
            width: 100,
            valueType: "date",
            // hideInForm: true,
            hideInSearch: true,
            sorter: true,
        },
        {
            title: '游戏发售日期',
            dataIndex: 'publishDate',
            align: 'center' as 'center',
            width: 100,
            valueType: "date",
            // hideInForm: true,
            hideInSearch: true,
            sorter: true,
        },
        {
            title: 'Ads游戏名搜索量',
            dataIndex: 'gameValue',
            align: 'center' as 'center',
            width: 100,
            valueType: "digit",
            hideInSearch: true,
            sorter: true,
            // render: (v: any, r:any) => <a onClick={() => openLogs("ads", r.id)}>{v}</a>
        },
        {
            title: "游戏关键词",
            dataIndex: "gameKey",
            width: 100,
        },
        {
            title: 'Ads关键词搜索量',
            dataIndex: 'keyValue',
            align: 'center' as 'center',
            width: 100,
            valueType: "digit",
            hideInSearch: true,
            sorter: true,
            // render: (v: any, r:any) => <a onClick={() => openLogs("ads", r.id)}>{v}</a>
        },
        {
            title: 'Ads更新',
            dataIndex: 'keyDate',
            align: 'center' as 'center',
            width: 100,
            valueType: "date",
            hideInSearch: true,
            sorter: true,
        },
        {
            title: '累计关键词',
            dataIndex: 'keysNum',
            align: 'center' as 'center',
            width: 100,
            hideInSearch: true,
            sorter: true,
            render: (v: any, r:any) => <a onClick={() => openKeys(r.id)}>{v}</a>
        },
        // {
        //     title: 'Trend',
        //     dataIndex: 'trendValue',
        //     align: 'center' as 'center',
        //     width: 100,
        //     hideInSearch: true,
        //     render: (v: any, r:any) => <a onClick={() => openLogs("trend", r.keyId)}>{v}</a>
        // },
        // {
        //     title: '7天文章',
        //     dataIndex: 'newsPercent',
        //     align: 'center' as 'center',
        //     width: 100,
        //     render: (v: any, r:any) => v != null && typeof v === 'number' ?
        //         <a onClick={() => openLogs("news", r.keyId)}>{(v * 100).toFixed(2) + "%"}</a>
        //         : '-',
        //     hideInSearch: true
        // },
        {
            title: '关键词更新',
            dataIndex: 'keysUpdate',
            align: 'center' as 'center',
            width: 100,
            valueType: "date",
            hideInSearch: true,
            sorter: true,
        },
        {
            title: "域名",
            dataIndex: '_domain',
            align: 'center' as 'center',
            width: 100,
            hideInSearch: true,
            render: (v: any, r:any) => <a onClick={() => openDomain(r.id)}>域名</a>
        },

    ];

    return (
        <MyProLayout>
            <ProTable
                rowKey={"id"}
                search={{span: 5}}
                actionRef={actionRef}
                columns={columns}
                cardBordered={true}
                request={async (
                    params,
                    sort,
                    // filter,
                ) => {
                    let orderBy = "keys_num desc"
                    for (const key in sort) {
                        orderBy = StringUtil.camelToSnake(key) + " "
                        orderBy += sort[key] === "descend" ? "desc" : "asc"
                    }
                    const query: any = {
                        query: {...params},
                        page: {
                            pageNo: params.current,
                            pageSize: params.pageSize,
                            orderBy: orderBy // params.orderBy ? params.orderBy : sortEnum[0].value
                        }
                    }
                    const res = await FetchUtil.awaitFetch('/mallApi/aiGame/gameList', query);
                    console.log(res)
                    return {
                        success: true,
                        data: res.data.list,
                        total: res.data.total,
                    };
                }}
            />
            <AiGameKeys ref={keysRef} />
            <AiGameLogs ref={logsRef} />
            <AiGameDomain ref={domainRef} />

        </MyProLayout>
    );
}

export default AiGameIndex;
